import communityItemConnector from "../community-item-connector"

import CommunityEditItem from "./CommunityEditItem"

export default communityItemConnector(CommunityEditItem)
